<template>
 	<div class="sous_block">
        <b-row>
            <b-col cols="4">
                <b-button class="button_hide_show" v-on:click="showdiv=!showdiv" variant="primary">Hide/Show</b-button>
            </b-col>
            <b-col cols="4"><h3 style="text-align: center;" >Local alignment</h3></b-col>
         </b-row>
         <b-row style="margin-top: 25px;">
	     	<b-col sm="5" md="6" class="my-1">
	        <b-form-group
	          label="Per page"
	          label-cols-sm="6"
	          label-cols-md="4"
	          label-cols-lg="3"
	          label-align-sm="right"
	          label-size="sm"
	          label-for="perPageSelect"
	          class="mb-0"
	        >
	          <b-form-select
	            v-model="perPage"
	            id="perPageSelect"
	            size="sm"
	            :options="pageOptions"
	          ></b-form-select>
	        </b-form-group>
	      </b-col>

	      <b-col sm="7" md="6" class="my-1">
	        <b-pagination
	          v-model="currentPage"
	          :total-rows="totalRows"
	          :per-page="perPage"
	          align="fill"
	          size="sm"
	          class="my-0"
	        ></b-pagination>
	      </b-col>
	    </b-row>
         <div id='tablemut' class="mut-table">
			<b-table striped bordered hover
			:items="items"
			:fields="fields"
			:sticky-header="stickyHeader"
			:sort-by.sync="sortBy"
			:sort-desc.sync="sortDesc"
			:current-page="currentPage"
      		:per-page="perPage"
			>
				<template v-slot:cell(show_details)="row">
			        <b-button size="sm" @click="row.toggleDetails" class="mr-2">
			          {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
			        </b-button>
			    </template>

			    <template v-slot:row-details="row">
			        <b-card>
			        	
			        </b-card>
		      	</template>



			</b-table>
		 </div>
 		
 	</div>
</template>
<script>

export default {
 		props: {
 			domSelected: [String,Array],
 			entryId: String,
 			seqInfo: [Object,Array]
 		},
        data(){
        	return {
        		
        		showdiv:true,
        		stickyHeader: true,
		        items: [],
		        fields: [
		          { key: 'protein_position', sortable: true },
		          { key: 'logo_position', sortable: true },
		          { key: 'ref', sortable: true },
		          { key: 'alt', sortable: true },
		          { key: 'Dolphin_AF', sortable: true },
		          { key: 'show_details', sortable: false }
		        ],
		        currentPage: 1,
		        perPage: 10,
		        pageOptions: [10, 15, 30],
		        totalRows: 1,
		        sortBy: 'protein_position',
        		sortDesc: false
		    }
        },
 		mounted() {
      		console.log('BOOTSTRAP TABLE Component mounted.')
      		this.create_table()
	    },
	    watch: {
	     //    seqInfo: function(val){
		    //   	this.create_table()
		    // }
    	},
    	methods:{
    		create_table(){
    			var pfid = [];
    			// console.log(this.domSelected)
    			// console.log(this.seqInfo)
    			if ($.type(this.domSelected) === 'string') {
    				pfid = [this.domSelected]
    			}else{
    				pfid = this.domSelected
    			}

    			self = this
    			var seqinfo = this.seqInfo
    			var truc = []
    			pfid.map(function(value){
    				seqinfo[value].all_mut.map(function(v){
    					//tab_details = this.get_details(value,v.pos_in_logo)
    					truc.push({
    						protein_position: 	v.pos_in_prot,
    						logo_position: 	v.pos_in_logo,
    						ref: 	v.aa_ref,
    						alt: 	v.aa_alt,
    						Dolphin_AF: 	new Number(v.max_af).toExponential(2),
    						//Dolphin_Popmax: 	new Number(v.max_popmax_freq).toExponential(2),
    						//details: self.get_details(pfid,v.pos_in_logo,v.aa_alt)
    					});
    				})
    				
    			})
    			this.totalRows = truc.length
    			this.items = truc
    		},
    		get_details(pfid,pos,alt){
    			axios
		          .get("/main/get_details/"+pfid+'/'+pos+'/'+alt)
		          .then( ({data}) => {
		            return data
		          })
		          .catch(error => console.log(error));
    		}
	    }
	    
	}

</script>